// src/pages/TextMessages/TextMessagesRightDrawer.tsx

import { useTheme } from "@mui/material/styles";
import ActionOnRecord from "components/Records/ActionOnRecord";
import { moveItemsBetweenNodes } from "api/Campaigns/CampaignAPI";
import { getLinkedPeopleFromInteraction } from "api/Interactions/InteractionAPI";

export default function TextMessageRightDrawer({
  textMessageId,
}: {
  textMessageId: number;
}) {
  const theme = useTheme();

  // --------------------------------------------------
  // Fetch people attached to the TextMessage interaction
  // --------------------------------------------------
  const fetchPeople = async () => {
    const people = await getLinkedPeopleFromInteraction("text_message", textMessageId);
    
    return people.map((p: any) => ({
      id: p.id,
      primary: `${p.first_name} ${p.last_name}`,
      secondary: p.phone_number,
    }));
  };
  
  // --------------------------------------------------
  // Send texts = move people forward through pathway
  // --------------------------------------------------
  const handleSendTexts = async (selected: any[]) => {
    if (!selected.length) return;

    await moveItemsBetweenNodes({
      item_field_name: "people",
      selected_items: selected.map(p => p.id),
      handle_name: "output-10",
      direction: "forward",
      interaction_id: textMessageId,
      interaction_type: "text_message",
    });

  };

  return (
    <ActionOnRecord
      fetchData={fetchPeople}
      onAction={handleSendTexts}
      primaryColor={theme.custom.modules.interactions.primary.dark}
      textColor={theme.custom.base.text.primary.dark}
      actionLabel="Log Texts"
    />
  );
}
